import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faChevronDown } from '@fortawesome/pro-solid-svg-icons/faChevronDown';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { CSSProperties, FunctionComponent } from 'react';
import { useTheme } from 'styled-components';
import { Container, Text, Pill } from './DropButton.style';

interface Props {
  ariaLabel?: string;
  ariaHasPopup?: boolean;
  ariaExpanded?: boolean;
  innerRef?: any;
  containerStyle?: CSSProperties;
  textStyle?: CSSProperties;
  tabIndex?: number;
  text: string;
  active: boolean;
  icon?: IconProp;
  iconActive?: boolean;
  role?: string;
  onClick: () => void;
  testID?: string;
  pill?: string;
}

const DropButton: FunctionComponent<Props> = (props) => {
  const theme = useTheme();

  return (
    <Container
      ref={props.innerRef}
      data-testid={props.testID}
      active={props.active}
      aria-label={props.ariaLabel}
      aria-haspopup={props.ariaHasPopup}
      aria-expanded={props.ariaExpanded}
      onClick={props.onClick}
      style={props.containerStyle}
      tabIndex={props.tabIndex}
      role={props.role}
      type="button"
    >
      {!!props.icon && (
        <FontAwesomeIcon
          icon={props.icon}
          color={props.iconActive ? theme.primary : theme.textDark}
          style={{ fontSize: 18 }}
          data-testid={`${props.testID}Icon`}
        />
      )}

      <Text data-testid={`${props.testID}Text`} style={props.textStyle}>
        {props.text} {props.pill && <Pill>{props.pill}</Pill>}
      </Text>

      <FontAwesomeIcon
        icon={faChevronDown}
        color={theme.textDark}
        style={{
          fontSize: 14,
        }}
      />
    </Container>
  );
};

export default DropButton;
